import '@/assets/main.scss'
import 'floating-vue/dist/style.css'

import {createApp} from 'vue'
import {createPinia} from 'pinia'
import FloatingVue from 'floating-vue'

import App from './App.vue'
import router from './router'

import {getAuthConfig} from '@/utils/env'
import {initAuth} from "@/shared/auth";

const app = createApp(App)

const authConfig = getAuthConfig()

app.use(createPinia())
app.use(router)
app.use(FloatingVue)

initAuth(app, authConfig)

app.mount('#app')
